import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectArsaOzellikleri, updateBaslikDefaults } from '../../../../redux/baslikSlice';

export default function ArsaOzellikleriSection() {
  const dispatch = useDispatch();
  const data = useSelector(selectArsaOzellikleri);

  const handleChange = (field, value) => {
    dispatch(updateBaslikDefaults({ section: 'arsaOzellikleri', changes: { [field]: value } }));
  };

  return (
    <div className="detail-section-content">
      <div className="detail-col-title">Yapi Sahibi</div>
      <div className="detail-field">
        <label>Adi Soyadi</label>
        <input type="text" value={data.yapiSahibiAdi} onChange={e => handleChange('yapiSahibiAdi', e.target.value)} />
      </div>
      <div className="detail-field">
        <label>Adres (Mahalle)</label>
        <input type="text" value={data.adres} onChange={e => handleChange('adres', e.target.value)} />
      </div>
      <div className="detail-field">
        <label>Ilce / Il</label>
        <input type="text" value={data.ilceIl} onChange={e => handleChange('ilceIl', e.target.value)} />
      </div>
      <div className="detail-field">
        <label>Vergi D. / No</label>
        <input type="text" value={data.vergiNo} onChange={e => handleChange('vergiNo', e.target.value)} />
      </div>

      <div className="detail-col-title" style={{ marginTop: 8 }}>Konum</div>
      <div className="detail-two-col">
        <div className="detail-col">
          <div className="detail-field">
            <label>Il</label>
            <input type="text" value={data.il} onChange={e => handleChange('il', e.target.value)} />
          </div>
          <div className="detail-field">
            <label>Ilce</label>
            <input type="text" value={data.ilce} onChange={e => handleChange('ilce', e.target.value)} />
          </div>
        </div>
        <div className="detail-col">
          <div className="detail-field">
            <label>Pafta</label>
            <input type="text" value={data.pafta} onChange={e => handleChange('pafta', e.target.value)} />
          </div>
          <div className="detail-field">
            <label>Ada</label>
            <input type="text" value={data.ada} onChange={e => handleChange('ada', e.target.value)} />
          </div>
          <div className="detail-field">
            <label>Parsel</label>
            <input type="text" value={data.parsel} onChange={e => handleChange('parsel', e.target.value)} />
          </div>
        </div>
      </div>
    </div>
  );
}
